import { UnitCancel, UnitMaster } from './reducer'

const FAILED_CANCELLATION_STATUSES = new Set(['failed', 'unpaid'])

export const getActiveCancellationRecord = (
  subscriptionId: string | number | undefined,
  cancelUnits: UnitCancel[]
) => {
  if (subscriptionId == null) return undefined

  return cancelUnits.find(
    (cancel) =>
      String(cancel.subscriptionId) === String(subscriptionId) &&
      cancel.isCanceled !== true
  )
}

export const getCancellationOperatorStatus = (cancelRecord?: UnitCancel) => {
  if (!cancelRecord || cancelRecord.isCanceled === true) return undefined
  if (cancelRecord.subscriptionCancelled === true) return 'Move-out pending'

  const paymentStatus = String(cancelRecord.paymentStatus ?? '').toLowerCase()
  if (FAILED_CANCELLATION_STATUSES.has(paymentStatus)) {
    return 'Cancellation needs review'
  }

  return 'Pending cancellation'
}

export const buildUnitOperatorStatus = ({
  unit,
  cancelUnits,
}: {
  unit: Pick<UnitMaster, 'customerProfileId' | 'subscriptionId'>
  cancelUnits: UnitCancel[]
}) => {
  if (unit.customerProfileId == null) return 'Available'

  return (
    getCancellationOperatorStatus(
      getActiveCancellationRecord(unit.subscriptionId, cancelUnits)
    ) ?? 'Occupied'
  )
}
